var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SIWEJwtBearerAuth_instances, _SIWEJwtBearerAuth_config, _SIWEJwtBearerAuth_options, _SIWEJwtBearerAuth_signer, _SIWEJwtBearerAuth_getAuthSession, _SIWEJwtBearerAuth_login, _SIWEJwtBearerAuth_createSiWELoginRawMessage, _SIWEJwtBearerAuth_assertSigner;
import { SiweMessage } from "siwe";
import { ValidationError } from "../errors.mjs";
import { validateLoginResponse } from "../utils/validate-login-response.mjs";
import { SIWE_LOGIN_URL, authenticate, authorizeOIDC, getNonce } from "./services.mjs";
export class SIWEJwtBearerAuth {
    constructor(config, options) {
        _SIWEJwtBearerAuth_instances.add(this);
        _SIWEJwtBearerAuth_config.set(this, void 0);
        _SIWEJwtBearerAuth_options.set(this, void 0);
        _SIWEJwtBearerAuth_signer.set(this, void 0);
        __classPrivateFieldSet(this, _SIWEJwtBearerAuth_config, config, "f");
        __classPrivateFieldSet(this, _SIWEJwtBearerAuth_options, options, "f");
    }
    async getAccessToken() {
        const session = await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_getAuthSession).call(this);
        if (session) {
            return session.token.accessToken;
        }
        const loginResponse = await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_login).call(this);
        return loginResponse.token.accessToken;
    }
    async getUserProfile() {
        const session = await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_getAuthSession).call(this);
        if (session) {
            return session.profile;
        }
        const loginResponse = await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_login).call(this);
        return loginResponse.profile;
    }
    async getIdentifier() {
        __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_assertSigner).call(this, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f"));
        return __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f").address;
    }
    async signMessage(message) {
        __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_assertSigner).call(this, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f"));
        return await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f").signMessage(message);
    }
    prepare(signer) {
        __classPrivateFieldSet(this, _SIWEJwtBearerAuth_signer, signer, "f");
    }
}
_SIWEJwtBearerAuth_config = new WeakMap(), _SIWEJwtBearerAuth_options = new WeakMap(), _SIWEJwtBearerAuth_signer = new WeakMap(), _SIWEJwtBearerAuth_instances = new WeakSet(), _SIWEJwtBearerAuth_getAuthSession = 
// convert expiresIn from seconds to milliseconds and use 90% of expiresIn
async function _SIWEJwtBearerAuth_getAuthSession() {
    const auth = await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_options, "f").storage.getLoginResponse();
    if (!validateLoginResponse(auth)) {
        return null;
    }
    const currentTime = Date.now();
    const sessionAge = currentTime - auth.token.obtainedAt;
    const refreshThreshold = auth.token.expiresIn * 1000 * 0.9;
    if (sessionAge < refreshThreshold) {
        return auth;
    }
    return null;
}, _SIWEJwtBearerAuth_login = async function _SIWEJwtBearerAuth_login() {
    __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_assertSigner).call(this, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f"));
    // Nonce
    const address = await this.getIdentifier();
    const nonceRes = await getNonce(address, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").env);
    const rawMessage = __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_createSiWELoginRawMessage).call(this, nonceRes.nonce);
    const signature = await this.signMessage(rawMessage);
    // Authenticate
    const authResponse = await authenticate(rawMessage, signature, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").type, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").env);
    // Authorize
    const tokenResponse = await authorizeOIDC(authResponse.token, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").env, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").platform);
    // Save
    const result = {
        profile: authResponse.profile,
        token: tokenResponse,
    };
    await __classPrivateFieldGet(this, _SIWEJwtBearerAuth_options, "f").storage.setLoginResponse(result);
    return result;
}, _SIWEJwtBearerAuth_createSiWELoginRawMessage = function _SIWEJwtBearerAuth_createSiWELoginRawMessage(nonce) {
    __classPrivateFieldGet(this, _SIWEJwtBearerAuth_instances, "m", _SIWEJwtBearerAuth_assertSigner).call(this, __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f"));
    return new SiweMessage({
        domain: __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f")?.domain,
        address: __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f")?.address,
        uri: SIWE_LOGIN_URL(__classPrivateFieldGet(this, _SIWEJwtBearerAuth_config, "f").env),
        version: '1',
        chainId: __classPrivateFieldGet(this, _SIWEJwtBearerAuth_signer, "f")?.chainId,
        nonce,
        issuedAt: new Date().toISOString(),
    }).prepareMessage();
}, _SIWEJwtBearerAuth_assertSigner = function _SIWEJwtBearerAuth_assertSigner(signer) {
    if (!signer) {
        throw new ValidationError(`you must call 'prepare()' before logging in`);
    }
};
//# sourceMappingURL=flow-siwe.mjs.map